import { gql } from "@apollo/client";

const PROCESS_INTELLI_UPLOAD_DOCUMENTS = gql`
  mutation ProcessQueue($params: IntelliUploadProcessQueueInput!) {
    processQueue(params: $params) {
      queueId
      processId
      isEmailSent
      isQueueCompleted
      isRuleTriggered
      documents {
        documentId
        purchaserName
        purchaserKey
        fileDisplayName
        fileName
        fileMimeType
        documentTypeId
        documentType
        documentSubtypeId
        documentSubtype
        claimNumber
        checkNumber
      }
    }
  }
`;

export default PROCESS_INTELLI_UPLOAD_DOCUMENTS;